<template>
    <div>
        <div class="bg-white sm:rounded-lg shadow-sm divide-y divide-gray-100">
            <div class="flex items-center px-6 py-4" v-for="receipt in receipts">
                <div class="text-sm">
                    {{ formatDate(receipt.paid_at) }}
                </div>

                <div class="ml-10 text-sm">
                    <span v-html="receipt.amount"></span>
                </div>

                <div class="ml-10">
                    <a class="underline text-sm text-gray-500"
                       :href="route('spark.invoice', {id: receipt.provider_id})" target="_blank"> Zobrazit fakturu </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import FormatsValues from './../Mixins/FormatsValues';

    export default {
        mixins: [FormatsValues],

        props: ['receipts'],
    }
</script>
